<template>
  <a-modal
    title="设置分组"
    :width="600"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @cancel="handleCancel"
  >
    <a-spin :spinning="confirmLoading || pullLoading">
      <a-form :form="form">
        <a-form-item label="请选择分组" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-select v-decorator="['group_id', {rules: [{required: true, message: '必填项'}]}]">
            <template v-for="(item,index) in dataSource">
              <a-select-option
                :key="index"
                :value="item.id"
              >{{item.group_name}}</a-select-option>
            </template>
          </a-select>
        </a-form-item>
      </a-form>
    </a-spin>
    <template slot="footer">
      <a-button @click="handleCancel">取消</a-button>
      <a-button :loading="confirmLoading" type="primary" @click="handleSubmit">确定</a-button>
    </template>
  </a-modal>
</template>

<script>
import DeviceGroupApi from '@/api/device-group'
export default {
  data() {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 }
      },
      mdl: {},
      visible: false,
      confirmLoading: false,
      pullLoading: false,
      form: this.$form.createForm(this),
      queryParam: {},
      dataSource: [],
      sub_ids: []
    }
  },
  methods: {
    show({ sub_ids }) {
      this.visible = true
      this.getData()
      this.sub_ids = sub_ids
    },
    getData() {
      this.pullLoading = true
      DeviceGroupApi.getList(
        Object.assign(this.queryParam, {
          pageSize: 200
        })
      )
        .then(res => {
          this.dataSource = res.data
        })
        .finally(() => {
          this.pullLoading = false
        })
    },
    handleCancel() {
      this.visible = false
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.confirmLoading = true
          DeviceGroupApi.setDeviceGroup({
            sub_ids: this.sub_ids,
            group_id: values.group_id
          })
            .then(res => {
              if (res.code === 1) {
                this.form.resetFields()
                this.$message.success('操作成功')
                this.visible = false
                this.$emit('ok')
              } else {
                this.$message.error(res.msg)
              }
            })
            .finally(() => {
              this.confirmLoading = false
            })
        }
      })
    }
  }
}
</script>
